module.exports = __webpack_public_path__ + "84854da6497c1a96651b75c9b4a65828.png";